import React from 'react';
import { getStatusColor, formatStatusLabel } from '../utils/statusColors';

/**
 * <StatusBadge status="wip" />
 * <StatusBadge status="enrolled" size="sm" />
 * <StatusBadge status="paid">Paid ₹999</StatusBadge>
 *
 * Uniform pill across the whole OPS panel.
 */
export const StatusBadge = ({ status, size = 'sm', children, className = '', ...rest }) => {
  const color = getStatusColor(status);
  const sizeClass = size === 'xs'
    ? 'text-[11px] px-2 py-0.5'
    : size === 'md'
      ? 'text-sm px-3 py-1'
      : 'text-xs px-2.5 py-0.5';

  return (
    <span
      className={`inline-flex items-center rounded-full font-medium border ${sizeClass} ${color} ${className}`}
      data-testid={`status-badge-${status || 'unknown'}`}
      {...rest}
    >
      {children || formatStatusLabel(status)}
    </span>
  );
};

export default StatusBadge;
